import {toast as reactToast} from 'react-toastify';
import {createToastFacade} from './createToastFacade';
import {ToastType} from './_types';

const toastTypes: Array<ToastType> = [
  'default',
  'primary',
  'danger',
  'success',
  'upgrade',
  'warning',
];

type Toast = {
  [key in ToastType]: ReturnType<typeof createToastFacade>;
} & {
  /**
   * Dismiss all toasts
   */
  dismiss: typeof reactToast.dismiss;
  /**
   * Get the hover state of the toast
   */
  getIsHovered: () => boolean;
};

/**
 * Creates a toast service object where each toast type (e.g., "success", "error", "warning")
 * is mapped to a corresponding toast function. This allows calling `toast.success()`, `toast.error()`, etc.,
 * without needing to manually specify the toast type each time.
 *
 * @constant {Toast} toast - An object containing toast functions for different types.
 * @example
 * toast.success("Operation completed!");
 * toast.error("Something went wrong!");
 */
const toast: Toast = toastTypes.reduce((toastService, type) => {
  toastService[type] = createToastFacade(type);
  return toastService;
}, {} as Toast);

// Replicate the dismiss API from react-toastify
toast.dismiss = reactToast.dismiss;
toast.getIsHovered = () => {
  const mouseLocation = document?.querySelectorAll(':hover') ?? [];
  return Array.from(mouseLocation).some((el) =>
    el.classList.contains('Toastify')
  );
};

export {toast};
